import React, { useState, useEffect } from 'react';
import { getClientManager } from '../../api/api';
import { useTheme } from '../../ThemeContext';

const ClientManager = ({ cManager, handleChange }) => {
    const { theme } = useTheme(); // Get the theme from context
    const [managers, setManagers] = useState([]);

    useEffect(() => {
        getClientManager().then(response => {
            setManagers(response.data);
        });
    }, []);

    return (
        <div >
            <label className="block text-sm mb-2 font-medium">
                Client Manager
            </label>
            <select
                onChange={handleChange}
                value={cManager}
                className={` w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
            >
                                <option value="" disabled>--Select--</option>

                {managers.map((manager) => (
                    <option key={manager._id} value={manager._id}>
                        {manager.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ClientManager;
